import { render, staticRenderFns } from "./TopluNotAlma.vue?vue&type=template&id=3ae9a1f4&scoped=true"
import script from "./TopluNotAlma.vue?vue&type=script&lang=ts"
export * from "./TopluNotAlma.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae9a1f4",
  null
  
)

export default component.exports